export default __webpack_public_path__ + "static/media/DNo.26-4.8279e920.jpg";